import { UnifiedTaskList } from '@/frontend/features/tasks/filterable-task-section'
import { useDocumentTitle } from '@/frontend/hooks/use-document-title'

export function TasksPage() {
  useDocumentTitle('Tasks')

  return (
    <div>
      <h1 className="text-headline-lg mb-4">Tasks</h1>
      <UnifiedTaskList />
    </div>
  )
}
